export function bannerSelect(urlImage){
    let img = document.querySelector('.content .img_cover');
    img.style.backgroundImage = `linear-gradient(rgba(255, 255, 255, 0.2), rgb(0, 0, 0)), ${urlImage}`;
    img.style.height = (screen.height + 1)+"px";
}

export function bannerHeight(){
    let img = document.querySelector('.content .img_cover');
    img.style.height = (screen.height + 1)+"px";
}